import type { MtBookingCardDataBooking, StoreCardItemPromoData } from '@presentation/components';
import type { MouseEventHandler } from 'react';

export interface MtBookingsPageData {
  upcomingItems?: MtBookingCardDataBooking[];
  items?: MtBookingCardDataBooking[];
  onProListClick?: MouseEventHandler;
  onDeleteBookingClick: (bookingId: number) => void;
  onUpdateBookingClick: (bookingId: number) => void;
  loading?: boolean;
}

export interface MtBookingsPageProps extends MtBookingsPageData {}
